import { selectPageTranslationData } from "../../api-integration/common.slice";
import { useAppSelector } from "../redux";

const usePageTranslation = () => {
  return useAppSelector(selectPageTranslationData);
};

export default usePageTranslation;